module.exports = __webpack_public_path__ + "img/legalxchain_ch_logo.6239cd17.png";